import { render } from "./SlotLiveMenu.vue?vue&type=template&id=37e536a0&scoped=true"
import script from "./SlotLiveMenu.vue?vue&type=script&lang=js"
export * from "./SlotLiveMenu.vue?vue&type=script&lang=js"

import "./SlotLiveMenu.vue?vue&type=style&index=0&id=37e536a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e536a0"]])

export default __exports__